import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import { useLoad } from '../../hooks/request'
import { ENTRANCE_LIST } from '../../urls'
import Select from '../../components/common/Select'

export default function ApartmentForm({ onCancel, onSubmit, loading, initialValues }) {
    const entrance = useLoad({ url: ENTRANCE_LIST })
    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                entrance: '',
                apartmentNumber: '',
                totalPrice: '',
                initialPayment: '',
                months: '',
                monthlyPayment: '',
                ...initialValues,
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">
                        <Select
                            options={entrance.response?.results ?? []}
                            name="entrance"
                            optionValue="id"
                            optionLabel={(e) => e?.entranceNumber ?? ''}
                            label="Падезд"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="apartmentNumber"
                            type="number"
                            label="Хона номери"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="totalPrice"
                            label="Квартира Умумий қиймати"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="initialPayment"
                            label="Бошланғич тўлови"
                            validate={required}
                            disabled={loading}
                        />
                        <Input
                            name="months"
                            label="Неча ойга"
                            validate={required}
                            disabled={loading}
                        />

                        <Input
                            name="monthlyPayment"
                            label="Ойлик Тўлов"
                            validate={required}
                            disabled={loading}
                        />

                    </div>
                </div>

                <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                    <div className="button-wrapper">
                        <Button
                            onClick={onCancel}
                            icon="close-outline"
                            text="Ёпиш"
                            className="is-danger"
                        />
                    </div>
                    <div className="button-wrapper">
                        <Button
                            loading={loading}
                            text="Сақлаш"
                            icon="add-outline"
                            type="submit"
                            className="is-success"
                        />
                    </div>
                </div>
            </Form>

        </Formik>
    )
}
